import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CodingOpportunities/patient-comment`;

/**
 * Crea un comentario a nivel de paciente en Coding Opportunities.
 *
 * @param {Object} params
 * @param {string} params.cipId - ID del paciente (CIP)
 * @param {number} params.employeeId - ID del empleado que crea el comentario
 * @param {string} params.authorRole - Rol del autor (e.g., "PCP", "CODER", "ADMIN")
 * @param {string} params.comment - Texto del comentario
 * @returns {Promise<Object>} - { message, commentId }
 */
const createPatientComment = async ({
  cipId,
  employeeId,
  authorRole,
  comment,
}) => {
  try {
    const response = await axios.post(
      API_URL,
      {
        cipId,
        employeeId,
        authorRole,
        comment,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating patient comment:", error);
    throw error;
  }
};

export default createPatientComment;
